var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronRightIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.94994 5.40845L2.23328 0.700112C2.15581 0.622005 2.06364 0.56001 1.96209 0.517703C1.86054 0.475395 1.75162 0.453613 1.64161 0.453613C1.5316 0.453613 1.42268 0.475395 1.32113 0.517703C1.21958 0.56001 1.12741 0.622005 1.04994 0.700112C0.894735 0.856247 0.807617 1.06746 0.807617 1.28761C0.807617 1.50777 0.894735 1.71898 1.04994 1.87511L5.17494 6.04178L1.04994 10.1668C0.894735 10.3229 0.807617 10.5341 0.807617 10.7543C0.807617 10.9744 0.894735 11.1856 1.04994 11.3418C1.12712 11.4205 1.21916 11.4832 1.32072 11.5261C1.42229 11.569 1.53136 11.5913 1.64161 11.5918C1.75187 11.5913 1.86094 11.569 1.9625 11.5261C2.06406 11.4832 2.1561 11.4205 2.23328 11.3418L6.94994 6.63345C7.03453 6.55541 7.10204 6.4607 7.14821 6.35528C7.19439 6.24987 7.21822 6.13603 7.21822 6.02095C7.21822 5.90586 7.19439 5.79202 7.14821 5.68661C7.10204 5.58119 7.03453 5.48648 6.94994 5.40845Z",
    fill: "#002145",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightIcon);
export default __webpack_public_path__ + "static/media/chevron_right_icon.6c95dab00a4d6bb0234405060df7e480.svg";
export { ForwardRef as ReactComponent };